import React from 'react';

interface SidebarItem {
  id: string;
  label: string;
  icon: string;
}

interface AdminMobileSidebarProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  sidebarItems: SidebarItem[];
  isOpen: boolean;
  onClose: () => void;
}

const AdminMobileSidebar: React.FC<AdminMobileSidebarProps> = ({
  activeTab,
  onTabChange,
  sidebarItems,
  isOpen,
  onClose
}) => {
  const handleTabChange = (tabId: string) => {
    onTabChange(tabId);
    onClose();
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="admin-mobile-overlay"
          onClick={onClose}
        ></div>
      )}

      {/* Mobile Sidebar */}
      <div className={`admin-mobile-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="admin-mobile-sidebar-header">
          <div className="admin-mobile-logo">
            <span className="admin-mobile-logo-icon">👑</span>
            <span className="admin-mobile-logo-text">Admin Panel</span>
          </div>
          <button 
            className="admin-mobile-close-btn"
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <div className="admin-mobile-badge">SUPER ADMIN</div>
        
        <nav className="admin-mobile-sidebar-nav">
          {sidebarItems.map(item => (
            <button
              key={item.id}
              className={`admin-mobile-nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => handleTabChange(item.id)}
            >
              <span className="admin-mobile-nav-icon">{item.icon}</span>
              <span className="admin-mobile-nav-label">{item.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </>
  );
};

export default AdminMobileSidebar;


